import { render, staticRenderFns } from "./PickItemRequest.vue?vue&type=template&id=4cf12008&scoped=true&"
import script from "./PickItemRequest.vue?vue&type=script&lang=js&"
export * from "./PickItemRequest.vue?vue&type=script&lang=js&"
import style0 from "./PickItemRequest.vue?vue&type=style&index=0&id=4cf12008&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf12008",
  null
  
)

export default component.exports